import Itinerary from './Itinerary';

export default Itinerary;
